//#region src/messages/attachSubjects.ts
var e = (e, t) => {
	let n = e.map((e) => e.role).lastIndexOf("user");
	if (n < 0 || t.length === 0) return e;
	let r = e[n], i = new Set((r.subjects ?? []).map((e) => e.id)), a = t.filter((e) => e.id && e.title && !i.has(e.id));
	if (a.length === 0) return e;
	let o = [...e];
	return o[n] = {
		...r,
		subjects: [...r.subjects ?? [], ...a]
	}, o;
};
//#endregion
export { e as attachSubjects };
